import {AuditableResult} from './auditable-result';
import {BrokenRule} from './broken-rule';

export class AuditableTransactionId extends AuditableResult<String> {
  constructor(transactionId: string, brokenRules: Array<BrokenRule> = new Array<BrokenRule>()) {
    super(transactionId, brokenRules);
  }

  static parseCreateTravelCreditTransactionResponse(json: Object) {

    let parser = (jsonObject: any) => jsonObject.transactionId;

    return AuditableResult.parseAuditableResult(json, parser)
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/auditable-transaction-id.ts